import type { MigrationInterface, QueryRunner } from 'typeorm'

export class AddDeletedAtToProjectsTable1686914235000
  implements MigrationInterface
{
  public async up(queryRunner: QueryRunner): Promise<void> {
    await queryRunner.query(`
            ALTER TABLE "projects" ADD COLUMN  "deleted_at" varchar;
        `)
  }

  public async down(queryRunner: QueryRunner): Promise<void> {
    await queryRunner.query(`
            ALTER TABLE "projects" DROP COLUMN "deleted_at";
        `)
  }
}
